import { IGridFilterEntityComponentResolver } from '../../../../libs/utils/ng-shared-components/src/lib/grid/grid-filter/grid-filter-entity/grid-filter-entity.component';
import { MiPspcGridFilterEntityComponent } from './grid-filter-entity.component';

export class GridFilterEntityComponentResolver implements IGridFilterEntityComponentResolver {
  getComponent() {
    return MiPspcGridFilterEntityComponent;
  }
}
